import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Companion_getInstancehzpw8lhng1eb as Companion_getInstance,
  AvatarTypedvyblcabyk2y as AvatarType,
} from '../AvatarType.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AvatarType_ResponseAdapterClass;
function AvatarType_ResponseAdapter() {
  if (AvatarType_ResponseAdapterClass === VOID) {
    class $ {
      s3z(reader, customScalarAdapters) {
        var rawValue = ensureNotNull(reader.d41());
        return Companion_getInstance().l6m(rawValue);
      }
      r6p(writer, customScalarAdapters, value) {
        writer.f41(value.o6m_1);
      }
      t3z(writer, customScalarAdapters, value) {
        return this.r6p(writer, customScalarAdapters, value instanceof AvatarType() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'AvatarType_ResponseAdapter', VOID, VOID, [Adapter()]);
    AvatarType_ResponseAdapterClass = $;
  }
  return AvatarType_ResponseAdapterClass;
}
var AvatarType_ResponseAdapter_instance;
function AvatarType_ResponseAdapter_getInstance() {
  return AvatarType_ResponseAdapter_instance;
}
//region block: init
AvatarType_ResponseAdapter_instance = new (AvatarType_ResponseAdapter())();
//endregion
//region block: exports
export {
  AvatarType_ResponseAdapter_instance as AvatarType_ResponseAdapter_instance32ktucgjbbtjc,
};
//endregion

//# sourceMappingURL=AvatarType_ResponseAdapter.mjs.map
